import * as THREE from 'three';
import { GameScene } from '../scenes/GameScene';
import { InputControllerConfig, InputControllerOptions } from './InputControllerConfig';

export class InputController {
  private config: InputControllerConfig;

  constructor(camera: THREE.PerspectiveCamera, gameScene: GameScene, options: InputControllerOptions = {}) {
    // Detect if the device is mobile
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    // Set default options based on device type
    const defaultOptions: InputControllerOptions = {
      useDPad: false,
      useKeyboard: !isMobile,
      useTouch: true
    };

    // Merge with provided options
    const finalOptions = {
      ...defaultOptions,
      ...options
    };

    this.config = new InputControllerConfig(camera, gameScene, finalOptions);
  }

  public update(deltaTime: number): void {
    this.config.update(deltaTime);
  }

  public dispose(): void {
    this.config.dispose();
  }

  public setOptions(options: InputControllerOptions): void {
    this.config.setOptions(options);
  }
} 